
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1413Dialog extends Serenity.EntityDialog<Report_1413Row, any> {
        protected getFormKey() { return Report_1413Form.formKey; }
        protected getIdProperty() { return Report_1413Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1413Row.localTextPrefix; }
        protected getNameProperty() { return Report_1413Row.nameProperty; }
        protected getService() { return Report_1413Service.baseUrl; }
        protected getDeletePermission() { return Report_1413Row.deletePermission; }
        protected getInsertPermission() { return Report_1413Row.insertPermission; }
        protected getUpdatePermission() { return Report_1413Row.updatePermission; }

        protected form = new Report_1413Form(this.idPrefix);

    }
}